export default __webpack_public_path__ + "static/media/solteiroduplo_10.0d862122.jpg";